import React, { createContext, useContext, useEffect, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "./firebaseConfig";

export interface MemberType {
    uid: string;
    name: string;
    phone: string;
    deleted: boolean;
    bankAccount: any[];
    savedKiosk: any[];
    timestamp: number;
    partnerId: string;
}

interface MemberContextType {
    members: MemberType[];
}

const MemberContext = createContext<MemberContextType | null>(null);

export const MemberProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [members, setMembers] = useState<MemberType[]>([]);

    useEffect(() => {
        const unsubscribe = onSnapshot(query(collection(db, "member")), async (snapshot) => {
            const membersLists = snapshot.docs
                .map((doc) => doc.data() as MemberType)
                .sort((a, b) => {
                    if (a.timestamp && b.timestamp) return a.timestamp - b.timestamp;
                    else return 0;
                });
            setMembers(membersLists);
        });

        return () => unsubscribe();
    }, []);

    return <MemberContext.Provider value={{ members }}>{children}</MemberContext.Provider>;
};

export const useMember = (): MemberContextType => {
    const context = useContext(MemberContext);
    if (!context) {
        throw new Error("usePoint must be used within a PointProvider");
    }
    return context;
};
